import {
  STD_CONTRACT_TEMPLATES, contractPlaceholderRaw, type ContractArticle, type ContractMergeData, type StdContractType,
} from './contract';
import { fillDocPlaceholders, parseDocMarkup, type DocBlock } from './contract-doc';

/**
 * Hợp đồng theo mẫu chuẩn Minh Tiến → các khối in: phần đầu mẫu (quốc hiệu, tên, căn cứ, hai bên) → các điều (tên in nguyên văn,
 * sửa được trên từng hợp đồng) → phần ký của mẫu. Ô trộn chưa có dữ liệu in chỗ trống gốc của mẫu. Dùng chung cho xem trước và Word / PDF.
 */
export function stdContractBlocks(type: StdContractType, articles: ContractArticle[], d: ContractMergeData): DocBlock[] {
  const tpl = STD_CONTRACT_TEMPLATES[type];
  const fill = (s: string) => fillDocPlaceholders(s, (n) => contractPlaceholderRaw(n, d));
  const blocks: DocBlock[] = [...parseDocMarkup(fill(tpl.head))];
  for (const a of articles) {
    blocks.push(...parseDocMarkup(`# ${fill(a.title).replace(/\n/g, ' ')}`));
    blocks.push(...parseDocMarkup(fill(a.body)));
  }
  blocks.push(...parseDocMarkup(fill(tpl.tail)));
  return blocks;
}

/** Checklist nội bộ của mẫu (không in cho khách) */
export function stdContractChecklist(type: StdContractType): string {
  return STD_CONTRACT_TEMPLATES[type].internal;
}
